import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=72d36054&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=72d36054&prod&lang=scss&scoped=true&"
import style1 from "./Records.vue?vue&type=style&index=1&id=72d36054&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d36054",
  null
  
)

export default component.exports